import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.idealRedirect($data.orderID))),
          type: "button"
        }, " Betaal met iDeal ")
      ]),
      _createElementVNode("td", null, [
        _createElementVNode("img", {
          alt: "iDeal",
          src: $data.idealLogo
        }, null, 8, _hoisted_1)
      ])
    ])
  ]))
}